import { render, staticRenderFns } from "./HeaderLanguageMenu.vue?vue&type=template&id=1b1aa76a&scoped=true&"
import script from "./HeaderLanguageMenu.vue?vue&type=script&lang=ts&"
export * from "./HeaderLanguageMenu.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderLanguageMenu.vue?vue&type=style&index=0&id=1b1aa76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1aa76a",
  null
  
)

/* custom blocks */
import block0 from "./HeaderLanguageMenu.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports